import styled from "styled-components";
import {DepositSideMenuItemIconDefaultBox} from "./deposit-side-menu-item-icon.default.box";


export const DepositSideMenuItemIconCasino888Box = styled(DepositSideMenuItemIconDefaultBox)`
    width: 26px;
    height: 26px;

    svg {
        width: 26px;
        height: 26px;
    }
`;
